/**
 * Prevent click event on accordion body
 */
document.querySelectorAll(".accordion__body").forEach(item => {
    item.addEventListener("click", function (e) {
        e.stopPropagation();
    });
});
